import { useQuestionizerStore } from "../types/state";
import Errors from "./errors";

export function Button(props: {label: string, className?: string, icon_left_class?: string, icon_right_class?: string, disabled?: boolean, onClick: () => void}){
  return <div role="button" 
              aria-label={props.label}
              aria-disabled={props.disabled} 
              tabIndex={0} 
              className={"btn step_buttons__button " + (props.disabled ? " btn--disabled " : '') +  (props.className || "")} 
              onClick={ (_) => props.onClick() }
              onKeyUp={ (event) => {
                if ((event.code != " ")  && (event.code != "Enter")) { return } 
                props.onClick();
              }}
            >
                {props.icon_left_class && <div className={"icon " + props.icon_left_class}></div>}
                <span>{props.label}</span>
                {props.icon_right_class && <div className={"icon " + props.icon_right_class}></div>}
            </div>;
  }